import type { CityConfig } from "../city-template/types";

export const jeffersonCityConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Jefferson City",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "jefferson-city",
  route: "/cities/jefferson-city",
  title: "Emergency Passport Jefferson City, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Jefferson City, MO — as fast as 24 hours. Serving Cole County and Central Missouri including the state capital. A+ BBB rated registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Jefferson City, MO",
  heroSubtitle: "State government trip to Ottawa and your passport is near expiration? Missouri Capitol conference and you need documents fast? Missouri River cruise with family and the kids need first passports? We help Jefferson City residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Jefferson%20City%20Missouri%20with%20the%20historic%20Missouri%20State%20Capitol%20building%20overlooking%20the%20Missouri%20River%20golden%20hour%20warm%20light%20illuminating%20the%20capitol%20dome%20and%20river%20bluffs%20tree-lined%20streets%20professional%20drone%20photography%20autumn%20colors%20soft%20natural%20tones%20Midwestern%20charm&width=1800&height=700&seq=jefferson-city-hero-2026&orientation=landscape",
  heroImageAlt: "Jefferson City Missouri State Capitol building overlooking the Missouri River at golden hour",
  geoPosition: "38.5767;-92.1735",
  geoPlacename: "Jefferson City, Missouri",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 380 miles northeast of Jefferson City via I-55",
  },
  nearbyCitiesZips: [
    { name: "Jefferson City", zips: "65101, 65102, 65109, 65110, 65111" },
    { name: "Columbia", zips: "65201, 65202, 65203, 65211, 65212" },
    { name: "Holts Summit", zips: "65043" },
    { name: "Fulton", zips: "65251" },
    { name: "Ashland", zips: "65010" },
    { name: "California", zips: "65018" },
    { name: "Eldon", zips: "65026" },
    { name: "Wardsville", zips: "65101" },
    { name: "Lake Ozark", zips: "65049" },
    { name: "Osage Beach", zips: "65065" },
    { name: "Rolla", zips: "65401, 65402" },
    { name: "Sedalia", zips: "65301" },
    { name: "Mexico", zips: "65265" },
    { name: "Moberly", zips: "65270" },
    { name: "Boonville", zips: "65233" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Central Missouri departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "State Capital Hub", desc: "Serving Jefferson City, Columbia, and all of Central Missouri" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Columbia, MO", route: "/cities/columbia-mo" },
    { name: "Fast passport renewal in St. Louis, MO", route: "/cities/st-louis" },
    { name: "Emergency passport help in Kansas City, MO", route: "/cities/kansas-city" },
    { name: "Urgent passport services in Springfield, MO", route: "/cities/springfield-mo" },
    { name: "Same-day passport help in Chicago, IL", route: "/cities/chicago" },
    { name: "Passport courier services in Des Moines, IA", route: "/cities/des-moines" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Jefferson City remotely via secure courier. We do not have a walk-in office in Jefferson City — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Cole County and Central Missouri.",
  fpcOfficeAddress: "1200 Main St, Kansas City, Missouri 64105",
  fpcOfficeDistance: "Serving all of Cole County and Central Missouri including Columbia, Fulton, Holts Summit, Ashland, and the Lake of the Ozarks region",
  serviceAreaIntro: "From the Capitol building and Missouri River bluffs to the growing suburbs of Holts Summit and Wardsville, from the college town energy of Columbia to the historic architecture of Fulton and the lake communities of Osage Beach and Lake Ozark — Fast Passport Center serves the entire Central Missouri region. We regularly help state employees, university staff, and families across Cole and Boone counties get their passports fast without the 6-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Jefferson City neighborhoods and the surrounding Central Missouri area including Columbia, Holts Summit, Fulton, Ashland, California, Eldon, Wardsville, Lake Ozark, Osage Beach, Rolla, Sedalia, and Mexico. If you are anywhere in Cole County or Central Missouri, we have you covered.",
  howItWorksIntro: "Most Jefferson City travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Jefferson City travelers often face a 6-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Jefferson City and Cole County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Jefferson City? Here are the most common ones we hear from Central Missouri travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/motor-vehicle/",
  dmvLabel: "Missouri DOR — Motor Vehicle & Driver Licensing",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Jefferson City travelers with immediate departure needs — as fast as 24 hours for urgent international flights from STL or COU.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Sarah M.",
      location: "Jefferson City, MO",
      rating: 5,
      text: "State government trade mission to Germany came up with one week notice. My passport had expired during COVID. Fast Passport Center got it in 30 hours. I represented Missouri abroad without a hitch!",
      service: "Passport Renewal",
    },
    {
      name: "David P.",
      location: "Holts Summit, MO",
      rating: 5,
      text: "Family emergency in Toronto. Fast Passport Center got my passport in 26 hours. The dedicated agent called me with updates. Incredible service for Central Missouri families.",
      service: "Emergency Passport",
    },
    {
      name: "Linda T.",
      location: "Columbia, MO",
      rating: 5,
      text: "MU study abroad program for my daughter needed a passport fast. Fast Passport Center handled the child passport process and got it in 4 days. Saved her semester!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "jefferson-city-1",
      name: "Jefferson City Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "131 W High St",
      city: "Jefferson City",
      state: "MO",
      zip: "65101",
      phone: "(573) 636-6167",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Jefferson City near the Capitol",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Jefferson City facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "jefferson-city-2",
      name: "Cole County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "311 E High St, Room 201",
      city: "Jefferson City",
      state: "MO",
      zip: "65101",
      phone: "(573) 634-9107",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Cole County Courthouse, downtown Jefferson City",
      website: "https://www.colecounty.org/206/County-Clerk",
      websiteLabel: "Cole County Clerk",
      notes: "Accepts passport applications. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "jefferson-city-3",
      name: "Columbia Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "511 E Walnut St",
      city: "Columbia",
      state: "MO",
      zip: "65201",
      phone: "(573) 876-7800",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles north of Jefferson City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Columbia and Boone County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "jefferson-city-4",
      name: "Fulton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "301 Court St",
      city: "Fulton",
      state: "MO",
      zip: "65251",
      phone: "(573) 642-4119",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles east of Jefferson City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Fulton and Callaway County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "jefferson-city-5",
      name: "Lake Ozark Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2423 Bagnell Dam Blvd",
      city: "Lake Ozark",
      state: "MO",
      zip: "65049",
      phone: "(573) 365-2792",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "45 miles south of Jefferson City",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lake of the Ozarks region. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 6 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Jefferson City photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Cole County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Jefferson City applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Central Missouri families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Jefferson City travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Jefferson City." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Jefferson City address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Jefferson City before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Jefferson City for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 6-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Jefferson City?", a: "Fast Passport Center offers fast passport renewal in Jefferson City in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Jefferson City?", a: "The nearest regional passport agency to Jefferson City is the Chicago Passport Agency, approximately 380 miles northeast via I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Jefferson City without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Jefferson City?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 6 hours from Jefferson City — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Cole County and Central Missouri residents." },
    { q: "Do you serve the entire Central Missouri region?", a: "Absolutely. Fast Passport Center serves the entire Central Missouri region including Jefferson City, Columbia, Fulton, Holts Summit, Ashland, Eldon, Lake Ozark, Osage Beach, and surrounding areas. Our courier service works seamlessly from any address in Cole County or Boone County." },
    { q: "Can I expedite a child passport in Jefferson City?", a: "Yes. Fast Passport Center expedites child passports in Jefferson City for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Central Missouri families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Jefferson City with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Jefferson City", address: "724 W Stadium Blvd, Jefferson City, MO 65109", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Jefferson City", address: "2100 Missouri Blvd, Jefferson City, MO 65109", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Jefferson City", address: "904 Ellis Blvd, Jefferson City, MO 65101", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Supercenter — Columbia", address: "415 Conley Rd, Columbia, MO 65201", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Jefferson City",
      address: "2319 St Marys Blvd, Jefferson City, MO 65109",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Missouri DOR — Columbia",
      address: "1500 Vandiver Dr, Suite 106, Columbia, MO 65202",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Columbia and Boone County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Missouri DOR — Fulton",
      address: "10 E 5th St, Fulton, MO 65251",
      hours: "Tue–Fri: 8AM–5PM",
      note: "Serves Callaway County. REAL ID available. Limited hours — call ahead.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "COU",
      name: "Columbia Regional Airport",
      distance: "25 miles north of Jefferson City",
      address: "11300 S Airport Dr, Columbia, MO 65201",
      note: "Regional airport with direct flights to Chicago and Dallas. About 30 minutes from Jefferson City via US-63.",
      flightUrl: "https://www.flycou.com/",
      flightLabel: "COU Airport",
      featured: true,
    },
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "125 miles east of Jefferson City",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major international hub. About 2 hours from Jefferson City via I-70.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: false,
    },
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "155 miles west of Jefferson City",
      address: "1 Kansas City Blvd, Kansas City, MO 64153",
      note: "Major international airport. About 2 hours 30 minutes from Jefferson City via I-70.",
      flightUrl: "https://www.flykc.com/",
      flightLabel: "MCI Airport",
      featured: false,
    },
  ],
};